import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';
import {paths} from "../paths";

const UserPage = lazy(() => import('src/pages/administrator/user'));
const OutsourcePage = lazy(() => import('src/pages/administrator/outsource'));
const OutsourceZonePage = lazy(() => import('src/pages/administrator/outsource-zone'));
const CompanyPage = lazy(() => import('src/pages/administrator/company'));
const RolePage = lazy(() => import('src/pages/administrator/role'));


export const AdministratorRoutes = [
    {
        path: 'administrator',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                path: paths.administrator.user,
                element: <UserPage/>
            },
            {
                path: paths.administrator.outsource,
                element: <OutsourcePage/>
            },
            {
                path: paths.administrator.outsourceZone,
                element: <OutsourceZonePage/>
            },
            {
                path: paths.administrator.company,
                element: <CompanyPage/>
            },
            {
                path: paths.administrator.role,
                element: <RolePage/>
            },
        ]
    }
];
